import { ContractProductStatusDto } from '@eneco/dc-be/client';

type AllowedColors = 'alpha' | 'warning' | 'error' | 'success' | 'highemphasis' | undefined;
export const PRODUCT_STATUS_COLOR_MAP = new Map<ContractProductStatusDto, AllowedColors>([
  ['Active', 'alpha'],
  ['InProgress', 'warning'],
  ['RequestedTermination', 'warning'],
  ['WaitingForApproval', 'warning'],
  ['WaitingForDelivery', 'warning'],
  ['None', 'error'],
  ['Terminated', 'error'],
]);
